import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import { t } from '@flows/core/i18n'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'

const pet_chip_number = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('chip_number')]:
        BaseSchema_PetHealthV1GetsafeDe.shape.chip_number
          .unwrap()
          .regex(/^(\d{15}|\d*)$/, t('sharedFlows_petHealth:steps.pet_chip_number.error'))
          .optional(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_chip_number.title',
          values: {
            pet_name: {
              type: 'dynamicValue',
              path: params.helperFunctions.getParamPath('pet_name'),
            },
          },
        },
      },
      {
        type: 'input',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('chip_number'),
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_chip_number.label',
        },
      },

      {
        type: 'infoBox',
        showInfoIcon: true,
        contentConfiguration: [
          {
            type: 'title',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_chip_number.infoBox.title',
            },
            isSmall: true,
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_chip_number.infoBox.text',
            },
          },
          {
            type: 'text',
            containsHTML: true,
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_chip_number.infoBox.text2',
            },
          },
          {
            type: 'text',
            containsHTML: true,
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_chip_number.infoBox.text3',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'pet_birthday',
  }) as const satisfies AnyStepConfiguration

export default pet_chip_number
